import {BehaviorSubject} from 'rxjs';
import {IDataSpell} from "../_interfaces/IDataSpell";

interface InfoSpell {
    popOpen: boolean
    popEl: HTMLElement | Element | null
    pop: IDataSpell | null
}

const InfoSpellSubscriber = new BehaviorSubject<InfoSpell>({popOpen: false, popEl: null, pop: null});

export {
    InfoSpellSubscriber
}
